/* eslint-disable global-require */
import 'babel-polyfill';
import { clientBootstrapper } from '@nike/vega';
import { rehydrate } from 'glamor';

import { analyticsReduxMiddleware } from '@nike/ux-tread-analytics-client';
import thunk from 'redux-thunk';
import {
  PAGELET_STATE_NAME as PDP_STORE_NAME,
  analyticsRules as pdpRules,
  neoEventCreators,
  createAnalyticsNeoMiddleware,
  isNeoEvent,
  createNeoEvent,
} from '@nike/pagelet-pdp';
import {
  PAGELET_STATE_NAME as WALL_STORE_NAME,
  analyticsRules as wallRules,
} from '@nike/pagelet-wall';
import {
  composeApp,
  initialState,
  createStore,
} from '@nike/pagelet-common';
import {
  globalRootReducer,
  browseEngine,
  newrelicEngine,
  useDotcomNav,
  initDotcomNav,
} from '@nike/browse-common';
import routes from './routes';

// =============================================================================
// Analytics middleware

// temporary: combine pdp and wall rules to get them both into the engine
const pageletAnalytics = { ...pdpRules, ...wallRules };
let pageletReducer = {};

if (initialState[PDP_STORE_NAME]) {
  const {
    pdpReducer,
  } = require('@nike/pagelet-pdp');

  pageletReducer = pdpReducer;
} else if (initialState[WALL_STORE_NAME]) {
  const {
    wallReducer,
  } = require('@nike/pagelet-wall');

  pageletReducer = wallReducer;
}

// =============================================================================
// Analytics middleware

initialState.pageletAnalytics = {
  ...pageletAnalytics,
};
const engine = browseEngine(
  initialState.Config.env
  , initialState.pageletAnalytics
);
const browseAnalytics = analyticsReduxMiddleware(engine);
const newrelicCustomEvents = analyticsReduxMiddleware(newrelicEngine);
const analyticsNeoMiddleware = createAnalyticsNeoMiddleware({
  eventCreators: neoEventCreators,
  isNeoEvent,
  createNeoEvent,
});

const storeConfig = {
  initialReducers: {
    ...globalRootReducer,
    ...pageletReducer,
    pageletAnalytics: () => initialState.pageletAnalytics,
  },
  initialState,
  middleware: [
    browseAnalytics,
    newrelicCustomEvents,
    analyticsNeoMiddleware,
    thunk,
  ],
};

const store = createStore(storeConfig);
rehydrate(window.glamor);

clientBootstrapper({
  routes,
  composeApplication: composeApp,
  store,
});

if (useDotcomNav(initialState)) {
  const dotcomNavEngine = browseEngine(
    initialState.Config.env,
    initialState.pageletAnalytics,
    store);
  initDotcomNav(store, dotcomNavEngine);
}



// WEBPACK FOOTER //
// ./packages/browse-app/src/client.js